// 指定した区切り文字でフォーマット
const formatDate = (date: string | Date, separator: string): string => {
  const formatted = new Date(date).toLocaleDateString('ja-JP', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: 'Asia/Tokyo',
  })
  return formatted.replace(/\//g, separator)
}

// 「YYYY.MM.DD」形式にフォーマット
export const formatDateToDisplay = (date: string | Date): string => formatDate(date, '.')

// 「YYYY/MM/DD」形式にフォーマット
export const formatDateSlash = (date: string | Date): string => formatDate(date, '/')

/**
 * 「YYYY年M月D日」をISO形式に変換
 * @param dateString - 日本語形式
 * @returns ISO形式
 */
export const formatJapaneseDateToISO = (dateString: string): string => {
  if (!dateString) return ''
  const datePattern = /^(\d{4})年(\d{1,2})月(\d{1,2})日$/
  const match = dateString.match(datePattern)
  if (match) {
    const [, year, month, day] = match
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
  }
  return dateString
}
